import { DbHelper } from "@app/shared/model/db-object.model";
import { ClassImporterExporter, ImportMap } from "@app/shared/resources/class-importer-exporter.service";

export enum ContactPhoneType {
    home = "Home",
    cell = "Cell",
    work = "Work",
}

export interface EmergencyContact {
    id: number;
    projectId: number;

    ecv: boolean;
    firstName: string;
    lastName: string;
    order: number;
    phone: number;
    phoneType: ContactPhoneType;

    authority: string | null;
    email: string | null;
    passcode: string | null;
    phoneExt: number | null;
    userId: string | null;
}

/* eslint-disable @typescript-eslint/naming-convention */
export interface EmergencyContactData {
    id: number;
    project_id: number;

    // TODO: Fix this column name in the DB
    evc: boolean;
    first_name: string;
    last_name: string;
    order_num: number;
    phone: number;
    phone_type: ContactPhoneType;

    authority: string | null;
    email: string | null;
    passcode: string | null;
    phone_ext: number | null;
    userid: string | null;
}
/* eslint-enable @typescript-eslint/naming-convention */

export class EmergencyContactHelper extends DbHelper<EmergencyContact, EmergencyContactData> {
    static readonly dbTypeName = "Emergency Contact";
    static readonly dbTypeNamePlural = "Emergency Contacts";

    static readonly importMap: ImportMap<EmergencyContact, EmergencyContactData> = [
        { i: "id", o: "id" },
        { i: "project_id", o: "projectId" },
        { i: "first_name", o: "firstName" },
        { i: "last_name", o: "lastName" },
        { i: "evc", o: "ecv" },
        { i: "authority", o: "authority" },
        { i: "phone", o: "phone" },
        { i: "phone_ext", o: "phoneExt" },
        { i: "phone_type", o: "phoneType" },
        { i: "order_num", o: "order" },
        { i: "email", o: "email" },
        { i: "passcode", o: "passcode" },
        { i: "userid", o: "userId" },
    ];

    static fromDbObject(dbObject: EmergencyContactData): EmergencyContact {
        return ClassImporterExporter.importObject(dbObject, EmergencyContactHelper.importMap);
    }

    static toDbObject(obj: EmergencyContact): EmergencyContactData {
        return ClassImporterExporter.exportObject(obj, EmergencyContactHelper.importMap);
    }

    static isValid(obj: EmergencyContact): boolean {
        return !!obj;
    }

    readonly importMap = EmergencyContactHelper.importMap;

    fromDbObject(emergencyContactData: EmergencyContactData): EmergencyContact {
        return EmergencyContactHelper.fromDbObject(emergencyContactData);
    }

    toDbObject(obj: EmergencyContact): EmergencyContactData {
        return EmergencyContactHelper.toDbObject(obj);
    }
}
